import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {scopes, resources} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {Icon, Modal, Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

const {
  updateAccessoriesRequests,
} = Actions;

const AccessoriesDeliveryConfirmationModal = ({
  request,
  disabled,
  filterState,
}) => {
  const permissions = useSelector((state) => state.session.permissions);
  const [detailCardVisible, setDetailCardVisible] = useState(false);
  const dispatch = useDispatch();

  const handleModal = (e, value) => {
    e.preventDefault();
    setDetailCardVisible(value);
  };
  
  const handleConfirmation = (e) => {
    e.preventDefault();
    dispatch(updateAccessoriesRequests({'request': request}, filterState));
    handleModal(e, false);
  };

  const handleDispatchButtonPermissions = () => {
    if (!hasAccessPermission(permissions, resources.AccessoriesRequest, scopes.Edit)) {
      return false;
    }
    return true;
  };

  const renderTriggerButton = () => {
    return handleDispatchButtonPermissions() ?
      <Button primary disabled={disabled} onClick={(e) => handleModal(e, true)}>Despachar pedido</Button> :
      null;
  };

  return (
    <Modal size='tiny'
      trigger={renderTriggerButton()}
      header={
        <div className='header flex'>
          <h2 className='flex grow' style={{'margin': 0}}>Confirmación de despacho</h2>
          <Icon className='download' name='close' style={{'margin': 0, 'cursor': 'pointer'}}
            onClick={(e) => handleModal(e, false)} />
        </div>
      }
      open={detailCardVisible}
      content={
        <div className="m-2" style={{'marginBottom': 0}}>
          <p style={{'textAlign': 'center'}}>
            ¿Está seguro que desea confirmar el despacho de accesorios para el pedido&nbsp;<b>{request}</b>?
          </p>
          <div className='flex' style={{'justifyContent': 'center', 'padding': '10px'}}>
            <Button primary className='download' onClick={(e) => handleConfirmation(e)}>
              <Icon name='check' />
              <span>Confirmar</span>
            </Button>
          </div>
        </div>
      }
    />
  );
};

export default AccessoriesDeliveryConfirmationModal;
